import { useMediaQuery, useTheme } from "@mui/material";

export const useResponsive = () => {
    const theme = useTheme();
    return {
        isMobile: useMediaQuery('(max-width:767px)'),
        isTabletNarrow: useMediaQuery('(min-width:768px) and (max-width:899px)'),
        isTabletWide: useMediaQuery('(min-width:900px) and (max-width:1024px)'),
        isDesktop: useMediaQuery('(min-width:1025px)'),
        theme,
    };
};
